module.exports = __webpack_public_path__ + "img/chat.2373a1a.jpg";